function Footer() {
  const today=new Date();
    return (
      <footer className='footer'>
        <p>POWERED BY YROS Software {today.getFullYear()}. For new projects contact 7896922693 </p>
      </footer>
    )
  }
  
  export default Footer